/**
 * Le lien « Mes notes » de la façade (C26 SP4, appel A18) : `/?dossier=<id>`. Paramètre minimal,
 * lu au démarrage de `Paperbase` (comme le retour de paiement), qui ouvre la section Notes sur ce
 * dossier puis disparaît de l'adresse. Un identifiant qui n'a pas la forme d'un identifiant de
 * dossier est ignoré : l'accueil s'ouvre comme d'habitude.
 */

const IDENTIFIANT = /^[0-9a-f]{24}$/i;

/** Le dossier demandé par l'adresse ; `null` si le paramètre est absent ou mal formé. */
export function readDossierParam(search: string): string | null {
    const valeur = new URLSearchParams(search || '').get('dossier');
    return valeur && IDENTIFIANT.test(valeur) ? valeur : null;
}

/** L'adresse sans le paramètre `dossier` (chemin, autres paramètres et fragment conservés). */
export function sansDossierParam(search: string): string {
    const params = new URLSearchParams(search || '');
    params.delete('dossier');
    const reste = params.toString();
    return reste ? `?${reste}` : '';
}

/**
 * Le lien vient de la façade : la personne n'est souvent pas encore connectée sur cette origine (MSAL est par
 * origine) et part vers `/login`, qui perd l'adresse. Le dossier est retenu dans `sessionStorage` — il survit à
 * l'aller-retour B2C dans le même onglet — puis repris une seule fois au démarrage (fumée SP4.13).
 */
const CLE_AVANT_CONNEXION = 'anagogia:dossierAvantConnexion';

export function retenirDossierAvantConnexion(search: string): void {
    const dossier = readDossierParam(search);
    if (!dossier) return;
    try { window.sessionStorage.setItem(CLE_AVANT_CONNEXION, dossier); } catch { /* stockage refusé : le lien ouvrira l'accueil */ }
}

export function reprendreDossierApresConnexion(): string | null {
    try {
        const valeur = window.sessionStorage.getItem(CLE_AVANT_CONNEXION);
        window.sessionStorage.removeItem(CLE_AVANT_CONNEXION);
        return valeur && IDENTIFIANT.test(valeur) ? valeur : null;
    } catch {
        return null;
    }
}

let dossierDemande: string | null = null;

/** Mémorise le dossier demandé pour la section Notes, qui le consomme quand ses notes sont chargées. */
export function demanderDossier(id: string | null): void {
    dossierDemande = id;
}

export function peekDossierDemande(): string | null {
    return dossierDemande;
}

export function consommerDossierDemande(): string | null {
    const id = dossierDemande;
    dossierDemande = null;
    return id;
}
